
import React from 'react';
import ScrollReveal from './ScrollReveal';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  title?: string;
  description?: string;
  faqs: FAQItem[];
}

const FAQSection: React.FC<FAQSectionProps> = ({ 
  title = "Frequently Asked Questions", 
  description = "Find answers to common questions about our services.",
  faqs 
}) => {
  return (
    <section className="py-20 bg-astrem-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <h2 className="text-3xl md:text-4xl font-display font-medium text-center mb-4">
            {title}
          </h2>
        </ScrollReveal>
        
        <ScrollReveal delay={100}>
          <p className="text-lg text-astrem-gray-600 text-center max-w-2xl mx-auto mb-12">
            {description}
          </p>
        </ScrollReveal>
        
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <ScrollReveal key={index} delay={200 + (index * 50)}>
                <AccordionItem value={`item-${index}`} className="bg-white border border-astrem-gray-200 rounded-lg overflow-hidden">
                  <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-astrem-gray-50 text-left font-medium">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-4 pt-2 text-astrem-gray-600">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </ScrollReveal>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
